export interface InitState {
  test: Boolean;
}

export const initialState: InitState = {
  test: true,
};
